import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_SERVICE_ORDER_STATE,
  CLEAR_SINGLE_SERVICE_ORDER,
  defaultServiceOrder,
  defaultServiceOrderState,
  FETCH_SERVICE_ORDER_APPROVAL_LIST_FAILED,
  FETCH_SERVICE_ORDER_APPROVAL_LIST_PROGRESS,
  FETCH_SERVICE_ORDER_APPROVAL_LIST_SUCCESS,
  FETCH_SERVICE_ORDER_LIST_FAILED,
  FETCH_SERVICE_ORDER_LIST_PROGRESS,
  FETCH_SERVICE_ORDER_LIST_SUCCESS,
  FETCH_SINGLE_SERVICE_ORDER_FAILED,
  FETCH_SINGLE_SERVICE_ORDER_PROGRESS,
  FETCH_SINGLE_SERVICE_ORDER_SUCCESS,
  ServiceOrderActions,
} from ".";

export const serviceOrderReducer = (
  state: IStoreState["serviceOrder"] = defaultServiceOrderState,
  action: ServiceOrderActions,
) => {
  switch (action.type) {
    case FETCH_SERVICE_ORDER_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.service_order_list.loading = LoadState.InProgress;
        draftState.service_order_list.data = [];
        draftState.service_order_list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_SERVICE_ORDER_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.service_order_list.loading = LoadState.Loaded;
        draftState.service_order_list.data = list;
        draftState.service_order_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_SERVICE_ORDER_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.service_order_list.loading = LoadState.InProgress;
        draftState.service_order_list.data = [];
        draftState.service_order_list.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_SINGLE_SERVICE_ORDER_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.single_service_order.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_SERVICE_ORDER_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_service_order.loading = LoadState.Loaded;
        draftState.single_service_order.data = data;
      });
      return newState;
    }
    case FETCH_SINGLE_SERVICE_ORDER_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_service_order.loading = LoadState.Failed;
        draftState.single_service_order.error = errorMessage;
      });
      return newState;
    }

    case FETCH_SERVICE_ORDER_APPROVAL_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.service_order_approval_List.loading = LoadState.InProgress;
        draftState.service_order_approval_List.list = [];
        draftState.service_order_approval_List.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_SERVICE_ORDER_APPROVAL_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.service_order_approval_List.loading = LoadState.Loaded;
        draftState.service_order_approval_List.list = data;
        draftState.service_order_approval_List.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_SERVICE_ORDER_APPROVAL_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.service_order_approval_List.loading = LoadState.InProgress;
        draftState.service_order_approval_List.list = [];
        draftState.service_order_approval_List.totalRecords = 0;
      });
      return newState;
    }

    case CLEAR_SINGLE_SERVICE_ORDER: {
      const newState = produce(state, (draftState) => {
        draftState.single_service_order.loading = LoadState.NotLoaded;
        draftState.single_service_order.data = defaultServiceOrder;
      });
      return newState;
    }
    case CLEAR_SERVICE_ORDER_STATE: {
      return defaultServiceOrderState;
    }

    default: {
      return state;
    }
  }
};
